import { render } from "./tcStallCustodyManage.vue?vue&type=template&id=44353e5f"
import script from "./tcStallCustodyManage.vue?vue&type=script&lang=js"
export * from "./tcStallCustodyManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__